import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import './TokenDistribution.css';

import token from '../../assets/images/distribution.png';

const TokenDistribution = () => {
  return (
    <section className="token-distribution-section" id="token">
      <Container>
        <div className="token-distribution-container">
          <div className="token-header">
            <h2 className="token-title">Token Distribution</h2>
            <div className="token-title-underline"></div>
          </div>

          <Row className="token-content">
            <Col lg="6" md="12" className="token-image-column">
              <div className="token-image-wrapper">
                <img
                  src={token}
                  alt="Token distribution chart"
                  className="token-image"
                />
              </div>
            </Col>

            <Col lg="6" md="12" className="token-info-column">
              <div className="token-info-card">
                <h3 className="token-info-title">Token Details</h3>
                <div className="token-info-item">
                  <span className="token-info-label">Total Supply:</span>
                  <span className="token-info-value">
                    200,000,000 <span className="token-symbol">MCGP</span>
                  </span>
                  <span className="token-info-label">Network:</span>
                  <span className="token-info-value">Sonic</span>
                </div>
                <div className="token-info-item">
                  <span className="token-info-label">Contract Address:</span>
                  <span className="token-info-value token-address">
                    0x517600323e5E2938207fA2e2e915B9D80e5B2b21
                  </span>
                </div>
                <div className="token-info-description">
                  <p>
                    The $MCGP token powers the entire MCGPchain ecosystem,
                    providing utility across our platform while enabling
                    governance for community-driven decision making.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default TokenDistribution;
